import React from 'react';

import './form-item-rt.less';

export type ListFromItemProps = {
    content?: string | React.ReactNode;
    arraw?: boolean;
    placeholder?: string;
} & Props;

const ListFromItemRt: React.FC<ListFromItemProps> = (props: ListFromItemProps) => {
    const { content, placeholder, arraw, className } = props;
    return (
        <div className={`commit-form-item-rt ${className ? className : ''}`} onClick={props.onClick}>
            <div className={`value-content ${!content && 'placeholder'}`}>
                {content ? content : placeholder}
                {!!content && !!arraw && <span className="value-arrow">重新选择</span>}
            </div>
            {!content && !!arraw && <div className="value-arrow">选择</div>}
        </div>
    );
};

ListFromItemRt.defaultProps = {
    placeholder: '请选择',
    arraw: true,
};

export default ListFromItemRt;
